




import "./NewEngineering.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../Images/manpower.jpeg'
import Aboutbg from '../Images/new_pic_8.png'
import Footer from "../Component/NewFooter";

const services = [
  {
    id: "valves",
    label: "Valves Asset Management",
    title: "At Jeyshawn Engineering Limited, we provide tailored manpower outsourcing solutions designed to support projects across all stages from start-up to commissioning.",
    intro:
      "Whether for short-term contract or long-term projects, we deliver a wide range of personnel, including:",
    sections: [
      {
        items: [
          "Unskilled, semi-skilled, and skilled workers for general operations.",
          "Technical staff for specialized engineering and operational roles.",
          "Operational and managerial personnel to ensure effective project leadership.",
          "Expert professionals for advisory, supervisory, and strategic roles.",
        ],
      }
    ],
    
    intro1:
      "Our rigorous selection and training processes ensure that all personnel are competent, reliable, and ready to integrate into client operations immediately. By providing the right people for the right positions, we help clients optimize productivity, maintain quality, and achieve project goals efficiently.",
      
    intro2:
      "With a commitment to excellence, safety, and professionalism, Jeyshawn Engineering Limited is a trusted partner for manpower solutions, delivering skilled and dependable human resources that drive project success.",
  }
];

 const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction & Camp Setup",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                 href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];



export default function ManPower() {
  return (
    <>
      <div className="img_carrier">
        <img src={Avatar1} alt="" />
      </div>

      <section className="service-detail"  style={{ backgroundImage: `url(${Aboutbg})` }}>
        <div className="service-detail__layout">

          {/* Left — Content (your existing JSX, unchanged) */}
          <div className="service-detail__content">
            <h2 className="service-detail__title">{services[0].title}</h2>
            <span className="service-detail__divider" />
            <p className="service-detail__intro">{services[0].intro}</p>
            {services[0].sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => (
                    <li key={j} className="service-detail__list-item">{item}</li>
                  ))}
                </ul>
              </div>
            ))}
            <p className="service-detail__intro">{services[0].intro1}</p>
            <p className="service-detail__intro">{services[0].intro2}</p>
          </div>

          {/* Right — Nav links instead of state buttons */}
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink
                key={s.href}
                to={s.href}
                className={({ isActive }) =>
                  `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`
                }
              >
                {s.label}
              </NavLink>
            ))}
          </nav>

        </div>
      </section>
      <Footer />
    </>
  );
}


 